<template>
    <ol class="list-decimal ml-6 mb-4 text-gray-900">
        <li class="mb-2 md:mb-1.5">
            本次受理案號申請內容為加密之PDF檔案，密碼為您登入時之要保人身分證字號(英文字母為大寫)。
        </li>
        <li class="mb-2 md:mb-1.5">
            若欲查詢保單變更處理之進度，請點選【<span
                class="text-link"
                @click="$emit('goPage', routeName.RECORD)"
            >申請紀錄</span>】查詢。
        </li>
        <li class="mb-2 md:mb-1.5">
            若您對於本次變更申請有任何疑問，請撥打本公司客戶服務專線0809-000-550洽詢。
        </li>
    </ol>
</template>
<script>
import routeName from '@/router/constant.js';
export default {
    emits: ['goPage'],
    setup() {
        return { routeName };
    },
};
</script>
